// Light Markdown for assistant answers (#52): models reply with **bold**, "* " bullets and the odd heading.
/** The light Markdown models write: headings and rules become bold lines, "* " bullets become "•", and **bold** / `code` render inline. */
export function tidyMarkdown(text: string): string {
  return text
    .replace(/^[ \t]*(?:-{3,}|\*{3,}|_{3,})[ \t]*$/gm, '')
    .replace(/^[ \t]*#{1,6}[ \t]+(.+?)[ \t]*#*$/gm, (_m, h: string) => `**${h.replace(/\*\*/g, '')}**`)
    .replace(/^([ \t]*)[*+-][ \t]+/gm, '$1• ')
    .replace(/\n{3,}/g, '\n\n');
}
/**
 * Splits text on **bold**, `code` and [label](/path) links, carrying an unclosed bold over to the next segment (a
 * citation can sit inside one). Only in-app links (starting with a single "/") become links (t126u: lists of
 * buildings, teams… link to each item); anything else stays plain text.
 */
export function inlineMarks(text: string, boldIn = false): { parts: { text: string; bold: boolean; code: boolean; href?: string }[]; boldOut: boolean } {
  const parts: { text: string; bold: boolean; code: boolean; href?: string }[] = [];
  let bold = boldIn;
  for (const tok of text.split(/(\*\*|`[^`\n]+`|\[[^\]\n]{1,200}\]\(\/(?!\/)[^)\s]{0,300}\))/)) {
    const link = /^\[([^\]\n]+)\]\((\/(?!\/)[^)\s]*)\)$/.exec(tok);
    if (tok === '**') bold = !bold;
    else if (link) parts.push({ text: link[1].replace(/\*\*/g, ''), bold, code: false, href: link[2] });
    else if (/^`[^`\n]+`$/.test(tok)) parts.push({ text: tok.slice(1, -1), bold, code: true });
    else if (tok) parts.push({ text: tok, bold, code: false });
  }
  return { parts, boldOut: bold };
}
